import React from "react";
import { createRoot } from "react-dom/client";
import { HashRouter, useLocation } from "react-router-dom";
import App from "./App";
import SetupWizard from "./pages/SetupWizard/SetupWizard";
import { MenuProvider } from "./contexts/MenuContext";

const root = createRoot(document.getElementById("ultimate-security-settings"));

// Wrapper component to detect current route and conditionally render layout
const RouterEntry = () => {
	const location = useLocation();

	// HashRouter gives us paths like "#/welcome"
	const isSetupWizardPage = location.pathname === "/more/setup-wizard";

	return isSetupWizardPage ? (
		<MenuProvider>
			<SetupWizard />
		</MenuProvider>
	) : (
		<MenuProvider>
			<App />
		</MenuProvider>
	);
};

root.render(
	<HashRouter>
		<RouterEntry />
	</HashRouter>,
);
